import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "rcards__stage" };
const _hoisted_2 = ["aria-hidden", "onClick"];
const _hoisted_3 = { class: "rcard__media" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "rcard__caption" };
const _hoisted_6 = { class: "rcard__title" };
const _hoisted_7 = {
    key: 0,
    class: "rcard__sub"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        ref: "root",
        class: "rcards",
        "aria-roledescription": "carousel",
        onMouseenter: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.onPause && _ctx.onPause(...args))),
        onMouseleave: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.onResume && _ctx.onResume(...args))),
        onFocusin: _cache[2] || (_cache[2] =
            //@ts-ignore
            (...args) => (_ctx.onPause && _ctx.onPause(...args))),
        onFocusout: _cache[3] || (_cache[3] =
            //@ts-ignore
            (...args) => (_ctx.onResume && _ctx.onResume(...args)))
    }, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleCards, (card) => {
                return (_openBlock(), _createElementBlock("article", {
                    key: card.itemIndex,
                    class: _normalizeClass(["rcard", [
                            `rcard--offset-${card.offset}`,
                            { 'rcard--active': card.offset === 0 },
                        ]]),
                    "aria-hidden": card.offset !== 0,
                    onClick: ($event) => (_ctx.goTo(card.offset))
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: card.item.image,
                            alt: card.item.title,
                            loading: "lazy"
                        }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(card.item.title), 1),
                        (card.item.subtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(card.item.subtitle), 1))
                            : _createCommentVNode("", true)
                    ])
                ], 10, _hoisted_2));
            }), 128))
        ])
    ], 544));
}
